import React, { PropsWithChildren } from 'react';
import { vibrate } from '../../Utils/Helpers';
import ButtonBase from './ButtonBase';

interface ButtonPrimaryProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const ButtonPrimary = ({
  children,
  onClick = () => {},
  disabled,
  rounded = false,
  className,
  outline = false,
  type = 'button'

}: PropsWithChildren<ButtonPrimaryProps>) => {

  const handleClick = () => {
    onClick();
    vibrate();
  }

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled}
      rounded={rounded}
      className={`
        text-base
        ${className} text-custom-primary ring-custom-primary hover:brightness-[110%] ring-2
        ${outline ? 'text-custom-primary text-custom-primary' : 'text-white bg-custom-primary'}
    `}>
      {children}
    </ButtonBase>
  )
}

export default ButtonPrimary;